import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated `/libraries/*` URLs.
 *
 * Kept separate from `libraries.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Full absolute strings (RR6 requires a child's path to start with its parent's).
 */
export const globalProductOfferingsRoute = defineRoute("/libraries/product-offerings");
export const productOfferingRoute = defineRoute("/libraries/product-offerings/:idOrAdd");
export const productOfferingCreateRoute = defineRoute("/libraries/product-offerings/add");
export const productOfferingEditRoute = defineRoute("/libraries/product-offerings/edit/:productOfferingId/:rpavId");
export const productOfferingScopeRoute = defineRoute("/libraries/product-offerings/:productOfferingId/scope/:rpavId");
export const productOfferingCostCalculatorRoute = defineRoute(
  "/libraries/product-offerings/:productOfferingId/cost-calculator/:rpavId",
);
export const productOfferingConfigPricingTraceRoute = defineRoute(
  "/libraries/product-offerings/checkout-pricing-trace/:configId",
);

export const planPackageRoute = defineRoute("/libraries/plan-packages/:planPackageId/:planPackageVersionId");
export const planPackageOverviewRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/overview",
);
export const planPackageElevationsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/elevations",
);
export const planPackageProgramDataRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/program-data",
);
export const planPackageLocationsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/locations",
);
export const planPackageOptionsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/options",
);
export const planPackageTakeoffsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/takeoffs",
);
export const planPackageCheckoutRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/checkout",
);
export const planPackageDocumentsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/documents",
);
export const planPackageVersionHistoryRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/history",
);

export const globalProductOfferingConfigsRoute = defineRoute("/libraries/product-offering-configs");
export const productOfferingConfigRoute = defineRoute(
  "/libraries/product-offering-configs/:productOfferingId/:idOrAdd",
);
export const productOfferingConfigEditRoute = defineRoute(
  "/libraries/product-offering-configs/:productOfferingId/edit/:productOfferingConfigId",
);
